import { ContractInfoState, ContractInfoStateType } from '@/states/ContractInfoState';
import { LoginUserInfoState } from '@/states/LoginUserInfoState';
import { useRecoilValue } from 'recoil';

/** 属性定義 */
type Props = {
  className?: string;
};
/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrFooterArea = ({
  className
}: Props) => {
  // ログインユーザー情報
  const loginUserInfo = useRecoilValue(LoginUserInfoState);
  // MANOMA Bizプラン 判定
  const contractInfo = useRecoilValue<ContractInfoStateType>(ContractInfoState);
  const isManomaBizPlan = loginUserInfo && contractInfo?.contractServiceInfo?.planInfo?.manomaBizPlanFlg === '1';
  const copyrightManoma = (): JSX.Element => {
    return <p>©2024 Life Elements Inc.</p>;
  };
  const copyrightManomaBiz = (): JSX.Element => {
    return <p>©2018 Sony Network Communications Inc.</p>;
  };
  return <footer className={`orfooterarea ${className}`}>
      {isManomaBizPlan ? copyrightManomaBiz() : copyrightManoma()}
    </footer>;
};
/** 初期値の設定 */
OrFooterArea.defaultProps = {
  className: ''
};
export default OrFooterArea;